<template>
  <div class="cart-item" v-if="datas" :class="{ 'is-loading': isLoading }">
    <div class="cart-item-wrapper">
      <p class="cart-item-title">
        {{ datas.variant.product.mainTaxon.name }}
        <span class="cart-item-title-option">
          {{ datas.variant.product.name }}
        </span>
        <template v-for="option in datas.variant.optionValues">
          <span class="cart-item-title-option" v-if="datas.variant.product.name !== option.value" :key="option.id">
            {{ option.value }}
          </span>
        </template>
      </p>
      <p class="cart-item-price">{{ (datas.unitPriceTtc * config.currency.rate/100)|toFixed(2) }} {{ config.currency.symbol }}</p>
      <div class="cart-item-quantity">
        <p class="cart-item-quantity-label">{{ Translator('front.product.add_item.quantity') }}</p>
        <button type="button" @click="onQuantityMinus" class="cart-item-quantity-button"
          :disabled="datas.quantity <= 1 || currentStep > 0">
          <i class="ico ico-minus"></i>
          <span class="hide-access">{{ Translator('front.product.add_item.minus') }}</span>
        </button>
        <p class="cart-item-quantity-value">{{ datas.quantity }}</p>
        <button type="button" @click="onQuantityMore" class="cart-item-quantity-button"
          :disabled="datas.quantity >= datas.variant.onHand || currentStep > 0">
          <i class="ico ico-more"></i>
          <span class="hide-access">{{ Translator('front.product.add_item.more') }}</span>
        </button>
      </div>
      <button type="button" class="cart-item-remove" @click="onRemove" v-if="currentStep === 0">{{
      Translator('front.product.add_item.delete') }}</button>
    </div>
  </div>
</template>
<style scoped lang="scss">
.cart-item {
  position: relative;
  transition: opacity .3s;
  margin-bottom: rem(30);
  &.is-loading {
    pointer-events: none;
    .cart-item-wrapper {
      opacity: .5;
    }
    @include loader($black, .7) {
      transform: none;
      bottom: rem(35);
      right: rem(5);
      top: auto;
      left: auto;
    }
  }
  .cart-item-price {
    @include upper;
  }
  .cart-item-container {
    margin-bottom: rem(30);
  }
  .cart-item-title {
    @include upper;
  }
  .cart-item-title-option {
    &::before {
      content: '/';
      margin-right: rem(5);
    }
  }
  .cart-propin-price {
    margin-bottom: rem(30);
  }
  .cart-item-quantity {
    display: flex;
    align-items: center;
  }
  .cart-item-quantity-label {
    @include upper;
    margin-right: rem(30);
  }
  .cart-item-quantity-button {
    @include resetBtn;
    @include upper;
    width: rem(30);
    height: rem(30);
    text-align: center;
    line-height: rem(20);
    margin-left: rem(5);
    margin-right: rem(5);
    &[disabled] {
      @include hidden;
    }
    .ico {
      font-size: rem(18);
      vertical-align: middle;
    }
  }
  .cart-item-remove {
    @include link;
  }
}
</style>
<script>
import debounce from 'debounce';
import AppControlService from '@/services/AppControl';
import OrdersService from '@/services/Orders';
import UsersService from '@/services/Users';

export default {
  props: ['datas'],
  name: 'cart-item',
  data () {
    return {
      user: UsersService.user,
      isLoading: false,
      currentStep: AppControlService.currentStep,
      config: window.config
    }
  },
  created() {
    this._onUpdateUser = this._onUpdateUser.bind(this);
    this._onUpdateStep = this._onUpdateStep.bind(this);
    AppControlService.on('step', this._onUpdateStep);
  },
  beforeDestroy() {
    UsersService.off('updated', this._onUpdateUser);
    AppControlService.off('step', this._onUpdateStep);
  },
  mounted() {
    UsersService.on('updated', this._onUpdateUser);
  },
  methods: {
    onEdit() {
      AppControlService.openAddCard(this.datas);
    },

    onQuantityMinus() {
      const newQuantity = this.datas.quantity - 1;
      if (newQuantity <= 0) return;
      this.datas.quantity = newQuantity;
      this._updateQuanty();
    },

    onQuantityMore() {
      const newQuantity = this.datas.quantity + 1;
      if (newQuantity > this.datas.variant.onHand) return;
      this.datas.quantity = newQuantity;
      this._updateQuanty();
    },

    onRemove() {
      this.isLoading = true;
      OrdersService.deleteItem(this.datas.id).then(() => {
        OrdersService.get().then().then(() => {
          this.isLoading = false;
        })
      }).catch(console.error);
    },

    _onUpdateStep(step) {
      this.currentStep = step;
    },

    _onUpdateUser(res) {
      this.user = res;
    },

    _updateQuanty: debounce( function() {
      this.isLoading = true;
      OrdersService.updateItem(this.datas.id, {quantity: this.datas.quantity}).then( () => {
        OrdersService.get().then().then( () => {
          this.isLoading = false;
        })
      }).catch( () => {
        this.isLoading = false;
      });
    }, 500),

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">

</style>
